import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { HeaderModel, LinkModel } from '@flocasts/experience-service-types'
import { trackById } from 'src/app/shared/utility-functions/track-by-id.utility'

@Component({
  selector: 'flo-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent implements OnInit {
  constructor(private readonly router: Router) {}
  ngOnInit(): void {
    // Only set the redirect query param if CTA has a router url.
    if (!!this.header?.cta1?.analytics?.entityId && !!this.header?.cta1?.url) {
      this.redirect = {
        redirect: `${this.router.url}${this.router.url.includes('?') ? '&' : '?'}coreNodeId=${
          this.header.cta1.analytics.entityId
        }`
      }
    }
  }

  public redirect?: Record<string, string>

  @Input() header?: HeaderModel

  @Output() headerCtaButtonClick = new EventEmitter<LinkModel>()

  handleLinkClick(link: LinkModel) {
    this.headerCtaButtonClick.emit(link)
  }

  public trackById = trackById
}
